module.exports = __webpack_public_path__ + "static/hero-5fbbdf9126fde7f28e1dc158740f72f9.jpg";